import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class Popup {
    @observable id!: number;

    @observable name!: string;
    @observable subdomain!: string;
    @observable design!: string;
    @observable enabled!: boolean;
    @observable customData!: string;

    constructor(popup?: ModelProperties<Popup>) {
        if (popup) {
            construct(this, popup);
        }
    }
}